module.exports = __webpack_public_path__ + "fonts/Montserrat_Regular_Latin.bc3aa95d.woff2";